import { render, staticRenderFns } from "./AccountingVatDeclarationModal.vue?vue&type=template&id=7b43162c&scoped=true"
import script from "./AccountingVatDeclarationModal.vue?vue&type=script&lang=ts"
export * from "./AccountingVatDeclarationModal.vue?vue&type=script&lang=ts"
import style0 from "./AccountingVatDeclarationModal.vue?vue&type=style&index=0&id=7b43162c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b43162c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b43162c')) {
      api.createRecord('7b43162c', component.options)
    } else {
      api.reload('7b43162c', component.options)
    }
    module.hot.accept("./AccountingVatDeclarationModal.vue?vue&type=template&id=7b43162c&scoped=true", function () {
      api.rerender('7b43162c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/AccountingVatDeclarationModal.vue"
export default component.exports